import { AppIcons } from "../constants/app-icons";
import { ApiService } from "./api.service";
import { PrimeIcons } from "@primevue/core/api";
export default class PropectService extends ApiService {
  namespace = "prospect";
  template = "defaultTemplate";
  DOMAIN = 145;
  icon = "GroupOfPeopleWithQuestion";
  singular = this.terminology.prospect.singular;
  plural = this.terminology.prospect.plural;
  vowel = this.terminology.prospect.vowel;
  name = this.singular;

  action = "action";
  Width = 1200;
  favicon = "GreenSilhouette";

  gemItems = [
    {
      key: "create",
      label: this.t("addAnEntity", { entity: this.singular }),
      icon: AppIcons.PLUS,
    },
    {
      key: "listing",
      label: this.t("allEntity", { entity: this.plural }),
      icon: AppIcons.BULLETS,
    },
    {
      key: "loader",
      label: this.t("emailEntity", { entity: this.plural }),
      icon: AppIcons.MAIL,
    },
    {
      key: "create",
      label: this.t("generateReport"),
      icon: AppIcons.DOCUMENT_EXCEL,
    },
  ];

  columns = [
    {
      header: this.t("displayName"),
      icon: AppIcons.USER_SILHOUETTE,
      field: "display_name",
    },

    {
      header: this.t("number"),
      icon: AppIcons.SHRED,
      field: "number",
    },

    {
      header: this.t("contact"),
      icon: AppIcons.YELLOW_SILHOUETTE,
      field: "contact",
    },

    {
      header: this.t("phone"),
      icon: AppIcons.MOBILE_PHONE,
      field: "phone",
    },
    {
      header: "Fax",
      icon: AppIcons.FAX,
      field: "fax",
    },
  ];
  navItems = [
    {
      key: "listing",
      label: this.t("allEntity", { entity: this.plural }),
      icon: AppIcons.BULLETS,
    },
    {
      key: "bookmark",
      label: this.t("viewMyBookmarks", { entity: this.singular }),
      icon: AppIcons.BOOKMARK,
    },
    {
      key: "inactive",
      label: this.t("viewInactiveEntity", { entity: this.plural }),
      services: 18,
      icon: AppIcons.DISABLE,
    },
  ];
  listMenuItems = [
    {
      key: "edit",
      label: "Open this Item...",
      icon: AppIcons.EDIT,
    },
    {
      key: "exec",
      label: "Copy this invoice...",
      icon: PrimeIcons.COPY,
      action: (item, ctx) => {
        ctx.$confirm.require({
          group: "templating",
          message: `You have selected the following Prospect to convert to a Customer: `,
          content: "This operation cannot be reversed once it is done.",
          dialogType: "confirm",
          accept: () => {
            ctx.emitter.emit("open-gem", {
              item: {
                key: "edit",
                label: "Copy - Customer",
                isVisible: true,
                service: 34,
                item: item,
              },
            });
          },
          reject: () => {
            console.log("nothing happened");
          },
        });
      },
    },
    {
      key: "announce",
      label: "announceThisEntity",
      services: -3,
      icon: AppIcons.BULLETS,
    },
    {
      key: "email",
      label: "emailThisEntity",
      icon: AppIcons.MAIL,
    },
    {
      key: "bookmark",
      label: "bookmarkThisEntity",
      icon: AppIcons.BOOKMARK,
    },
    {
      key: "inactive",
      label: "inactiveThisEntity",
      icon: AppIcons.LOCK2,
    },
  ];
  gemMenuItems = [
    {
      key: "create",
      label: "Adding an Prospect",
      icon: PrimeIcons.LIST,
    },
  ];

  constructor() {
    super("prospects");
  }
}
